import { Component, OnInit, HostListener, Inject, PLATFORM_ID, NgZone, ChangeDetectorRef } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ToastContainerComponent } from './components/toast-container.component';
import { AuthService, User } from './services/auth.service';
import { SidebarComponent } from './components/sidebar.component';
import { ProjectSettingsComponent } from './components/project-settings.component';
import { UserProfileModalComponent } from './components/user-profile-modal.component';
import { AssetManagerComponent } from './components/asset-manager.component';
import { SettingsService } from './services/settings.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastContainerComponent, CommonModule, SidebarComponent, ProjectSettingsComponent, UserProfileModalComponent, AssetManagerComponent],
  templateUrl: './app.html',
  styleUrls: ['./app.css']
})
export class App implements OnInit {
  isLoggedIn = false;
  isMobile = false;
  isSidebarOpen = false;
  showSettings = false;
  showUserModal = false;
  showAssets = false;

  constructor(
    private router: Router,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    private authService: AuthService,
    private settingsService: SettingsService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit(): void {
    this.authService.currentUser$.subscribe((user: User | null) => {
      this.isLoggedIn = !!user;
    });

    if (isPlatformBrowser(this.platformId)) {
      this.checkScreenSize();
      // Ensure settings are loaded — only in browser, not during SSR
      this.settingsService.loadSettings();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(_event: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.checkScreenSize();
    }
  }

  private checkScreenSize() {
    this.isMobile = window.innerWidth < 1024;
    if (!this.isMobile) {
      this.isSidebarOpen = true;
    } else {
      this.isSidebarOpen = false;
    }
  }

  onLogout() {
    this.authService.logout().subscribe({
      next: () => {
        this.ngZone.run(() => {
          this.router.navigate(['/login']);
          this.cdr.detectChanges();
        });
        this.showUserModal = false;
      },
      error: (err) => {
        console.error('Logout error:', err);
        this.ngZone.run(() => {
          this.router.navigate(['/login']);
          this.cdr.detectChanges();
        });
      }
    });
  }
}
